import * as $ from 'jquery';
import {Global} from '../init-global';
import 'slick-carousel';


export class CarouselBanner {

    protected $window: JQuery;
    protected $root: JQuery;
    protected $carouselWrapper: JQuery;
    protected $carouselNav: JQuery;
    protected $scrollNext: JQuery;
    protected $scrollPrev: JQuery;


    constructor(elem: HTMLElement)
    {
        this.$window  = $(<any>window);
        this.$root    = $(elem);
        this.bindUI();
    }

    private bindUI = () => {
        this.$carouselWrapper = $('.c-carousel-banner__list', this.$root);
        this.$scrollNext      = $('.c-carousel-banner__scroll-right', this.$root);
        this.$scrollPrev      = $('.c-carousel-banner__scroll-left', this.$root);
        this.$carouselNav     = $('.js-carousel-nav', this.$root);
        this.initCarousel();
    }

    private initCarousel = () => {
        this.$carouselWrapper.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 800,
            nextArrow: this.$scrollNext,
            prevArrow: this.$scrollPrev,
            dots: true,
            rows: 0
        });



        if (typeof this.$carouselNav != 'undefined') {
            this.$carouselWrapper.on('beforeChange', (event, slick) => {
                $('button', this.$carouselNav).removeClass('c-carousel-nav__link--active').removeAttr('aria-selected');
            });
            this.$carouselWrapper.on('afterChange', (event, slick, currentSlide) => {
                this.updateTabs($('button', this.$carouselNav).eq(currentSlide), currentSlide);
            });
            $('button', this.$carouselNav).eq(this.$carouselWrapper.slick('slickCurrentSlide')).addClass('c-carousel-nav__link--active').attr('aria-selected', 'true');
            this.$carouselNav.on({
                click: (e:any) => {
                    this.$carouselWrapper.slick('slickGoTo', $(e.currentTarget).parent('li').prevAll().length);
                    this.updateTabs($(e.currentTarget), this.$carouselWrapper.slick('slickCurrentSlide'));
                }
            }, 'button');
        }
    }

    private updateTabs = ($target:JQuery, index:number) => {
        $('button', this.$carouselNav).removeClass('c-carousel-nav__link--active').removeAttr('aria-selected');
        $target.addClass('c-carousel-nav__link--active').attr('aria-selected', 'true');
    }
}